(function () {
  const overlay = document.getElementById('mandira-mobile-overlay');
  const openBtn = document.querySelector('.header-menu-mobile-toggle');
  const closeBtn = overlay?.querySelector('[data-mobile-menu-close]');
  const shopToggle = overlay?.querySelector('[data-mobile-shop-toggle]');
  const shopPanel = overlay?.querySelector('[data-mobile-shop-panel]');
  if (!overlay || !openBtn) return;

  function isOpen() {
    return overlay.classList.contains('expanded');
  }

  function setToggleState(open) {
    openBtn.classList.toggle('is-open', open);
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    openBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.documentElement.classList.toggle('mobile-menu-open', open);
  }

  function openMenu() {
    const header = document.querySelector('.site-header');
    if (header) {
      header.classList.add('site-header--solid');
      header.classList.remove('site-header--transparent', 'site-header--hidden');
    }
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('expanded');
      setToggleState(true);
    });
  }

  function closeMenu() {
    if (!isOpen() && overlay.hidden) return;
    overlay.classList.remove('expanded');
    setToggleState(false);
    window.setTimeout(() => {
      if (!isOpen()) overlay.hidden = true;
    }, 400);
  }

  function toggleMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    if (isOpen()) closeMenu();
    else openMenu();
  }

  openBtn.addEventListener('click', toggleMenu);
  closeBtn?.addEventListener('click', closeMenu);
  overlay.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });

  shopToggle?.addEventListener('click', () => {
    const open = shopToggle.classList.toggle('is-open');
    shopToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (shopPanel) shopPanel.hidden = !open;
  });
})();

/* Desktop Shop mega-menu — keep open across header gap with close delay */
(function () {
  const dropdownItem = document.querySelector('.header-menu-desktop .has-dropdown');
  const dropdown = dropdownItem?.querySelector('.header-dropdown');
  if (!dropdownItem || !dropdown) return;

  const CLOSE_DELAY_MS = 450;
  let closeTimer = null;

  function setOpen(open) {
    dropdownItem.classList.toggle('is-open', open);
    dropdown.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function cancelClose() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(() => {
      setOpen(false);
      closeTimer = null;
    }, CLOSE_DELAY_MS);
  }

  dropdownItem.addEventListener('mouseenter', () => {
    cancelClose();
    setOpen(true);
  });
  dropdownItem.addEventListener('mouseleave', scheduleClose);
  dropdown.addEventListener('mouseenter', () => {
    cancelClose();
    setOpen(true);
  });
  dropdown.addEventListener('mouseleave', scheduleClose);

  dropdownItem.addEventListener('focusin', () => {
    cancelClose();
    setOpen(true);
  });
  dropdownItem.addEventListener('focusout', (event) => {
    if (dropdownItem.contains(event.relatedTarget)) return;
    scheduleClose();
  });
})();
